import { FC } from 'react';

import { Coupon } from '@assets/icons';
import { useAuthState } from '@contexts/auth/AuthContext';

import { LabelWrapper, MileWrapper } from './styled';
import { Rectangle } from '../styled';

const HeaderMile: FC = () => {
  const {
    userInfo: { totalRewardAmount },
  } = useAuthState();
  const totalPrice = totalRewardAmount / 100;
  return (
    <MileWrapper>
      {totalRewardAmount && totalRewardAmount > 0 ? (
        <>
          <Coupon />
          <LabelWrapper>
            {totalPrice} değerinde {totalRewardAmount} miliniz var.
          </LabelWrapper>
          <Rectangle />
        </>
      ) : null}
    </MileWrapper>
  );
};

export default HeaderMile;
